/*!
 * doTERRA CRM
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, {useMemo, useState} from 'react';
import {DoterraSelect, Field, TextField} from '../../shared/components/fields';
import {Button, Icon} from "../../shared/components/controls";
import {useFormState} from '../../shared/components/form';
import {getFormatter} from '../../shared/data';
import {text} from '../../shared/utils/i18n';
import {defaultPostalCodeFormatter} from "../../shared/utils/common";
import {flushSync} from "react-dom";

const BillingAddressLine2 = () => {
    const [showBillingAddress2, setShowBillingAddress2] = useState(false);
    const newLine2ContainerStyling = {
        marginTop:"15px",
        position:"relative",
        cursor:"pointer"
    };
    const newLineTextStyling = {
        position: "absolute",
        left:"35px"
    };

    const handleShowBillingAddress2 = () => {
      flushSync(() => {
        setShowBillingAddress2(true);
      });
    };
    if (showBillingAddress2) {
        return <Field component={TextField} name="billingLine2" id="billingAddressLine2" labelKey="form.paymentManagement.billingLine2.label" classes="form-control" maxLength="35" />;
    } 
        return (
            <div onClick={handleShowBillingAddress2} style={newLine2ContainerStyling}>
                <Icon name={'add-circle'} size={'small'}/>
                <span style={newLineTextStyling}>{text("form.paymentManagement.addSecondLine")}</span>
            </div>
        );
    
};

export const AddressSection = (props) => {
    const leftCenter = {
        paddingLeft: "0"
    };
    const { values } = useFormState();
    const { mode, hideSection, regions, market, useSavedAddress } = props;

    let isZipCodeValid = '';
    let regexExp = new RegExp(regions[1].postalCode.pattern);
    isZipCodeValid = regexExp.test(values.billingZip);
    if(mode === 'edit') {
      isZipCodeValid = true;
    }
    const [ postalValidity, setPostalValidity ] = useState(isZipCodeValid);

    const regionOptions = regions[0].map((region) => {
      return {label:region.name, value: region.isocodeShort};
    });
    const formatter = useMemo(()=> getFormatter(market, 'postalCode') || defaultPostalCodeFormatter,[market]);

    const handleKeyUp = (element) => {
        let regexExp = new RegExp(regions[1].postalCode.pattern);
        let isValid = regexExp.test(element.value);
        if(!isValid) {
          flushSync(() => {
            setPostalValidity(false);
          });
        } else {
          flushSync(() => {
            setPostalValidity(true);
          });
        }
    };
    return (
        <>
            <div className="form-group">
                <Field component={TextField} name="billingLine1" id="billingAddressLine1" labelKey="form.paymentManagement.billingLine1.label" classes="form-control" maxLength="35" />
            </div>
            <div className="form-group">
                <BillingAddressLine2/>
            </div>
            <div className="form-group">
                <Field component={TextField} id="billingAddressCity" name="billingCity" labelKey={`form.paymentManagement.billingCity.label.${market}`} classes="form-control" maxLength="35" />
            </div>
            <div className="form-group">
                <Field component={DoterraSelect} name="billingState" id="billingAddressState" labelText={text(`form.paymentManagement.billingState.label.${market}`)}
                       labelClasses='dropdown-label' options={regionOptions}/>
            </div>
            <div className="form-group">
                <Field component={TextField} id="billingAddressZip" name="billingZip" labelKey={`form.paymentManagement.billingZip.label`}
                       classes="form-control" template={formatter} useRestricted={true} onKeyUp={e => handleKeyUp(e.target)} valid={postalValidity}/>
            </div>
            {useSavedAddress &&
                <Button id="billingAddressUsedSaved" disabled={false} text={text("form.paymentManagement.useSaveAddress")} classes={"btn btn-link"} onClick={hideSection} cssStyles={leftCenter}/>
            }
        </>

    );
};
